import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { toast } from 'sonner';
import { LogIn, UserPlus } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isRegistering, setIsRegistering] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    role: 'agent'
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await login(formData.email, formData.password);
      toast.success('Inicio de sesión exitoso');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const { register } = await import('../services/api').then(m => m.authAPI);
      await register(formData);
      toast.success('Registro exitoso. Ahora puedes iniciar sesión');
      setIsRegistering(false);
      setFormData({ ...formData, full_name: '', role: 'agent' });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-bg"></div>
      <div className="login-content">
        <div className="login-header">
          <img src="/ikons-logo.png" alt="Ikons Agency" className="login-logo-image" />
          <p className="login-tagline">Sistema de Gestión de Leads</p>
        </div>

        <Card className="login-card">
          <CardHeader>
            <CardTitle>{isRegistering ? 'Crear Cuenta' : 'Iniciar Sesión'}</CardTitle>
            <CardDescription>
              {isRegistering 
                ? 'Crea una cuenta para acceder al dashboard' 
                : 'Ingresa tus credenciales para acceder al CRM'}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={isRegistering ? handleRegister : handleLogin} className="login-form">
              {isRegistering && (
                <div className="form-group">
                  <Label htmlFor="full_name">Nombre Completo</Label>
                  <Input
                    id="full_name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleInputChange}
                    placeholder="Edgar Merino"
                    required
                  />
                </div>
              )}
              
              <div className="form-group">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="email@ejemplo.com"
                  required
                />
              </div>

              <div className="form-group">
                <Label htmlFor="password">Contraseña</Label>
                <Input
                  id="password"
                  name="password"
                  type="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="••••••••"
                  required
                />
              </div>

              <Button type="submit" className="btn-login" disabled={loading}>
                {loading ? (
                  'Procesando...'
                ) : isRegistering ? (
                  <>
                    <UserPlus className="btn-icon" />
                    Registrarse
                  </>
                ) : (
                  <>
                    <LogIn className="btn-icon" />
                    Iniciar Sesión
                  </>
                )}
              </Button>

              <div className="login-toggle">
                {isRegistering ? (
                  <p>
                    ¿Ya tienes cuenta?{' '}
                    <button type="button" onClick={() => setIsRegistering(false)} className="toggle-link">
                      Inicia sesión aquí
                    </button>
                  </p>
                ) : (
                  <p>
                    ¿No tienes cuenta?{' '}
                    <button type="button" onClick={() => setIsRegistering(true)} className="toggle-link">
                      Regístrate aquí
                    </button>
                  </p>
                )}
              </div>
            </form>

            <div className="login-back">
              <Link to="/" className="back-link">
                ← Volver al sitio principal
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
